import { IonDatetime, IonItem, IonLabel } from "@ionic/react"
import dayjs from 'dayjs'
import React from "react"

interface Props {
  value: string
  onChange: (value: string) => void
}

const FormRiskStartDate: React.FC<Props> = props => {
  const max = dayjs().add(2, 'year').format('YYYY-MM-DD')
  const min = dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD')

  return (
    <IonItem>
      <IonLabel position="floating">Start Datum</IonLabel>
      <IonDatetime
        min={min}
        max={max}
        value={props.value}
        displayFormat={'YYYY-MM-DD'}
        onIonChange={e => props.onChange((e.target as HTMLInputElement).value)}
      />
    </IonItem>
  )
}

export default FormRiskStartDate
